import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Slå WhatsApp-notifikationer til',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Automatiske opkald om afventende ordrer',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Åbningstider',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Placering',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Restaurantens identitet',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Afhentningstid',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Leveringstid',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Personalelogin',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importér menu',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Favoritter',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Udsolgte varer',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Rabatkoder',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galleri',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Tilføj restaurantens logo og primærfarve',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Bestil flyers',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Opret storefront',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Aktivér live-bestillinger',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Aktivér Google Business',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Tjek, om ejeren/kontaktpersonen har WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Tjek, at restaurantens nummer er korrekt, så automatiske opkald ikke får dig til at misse ordrer',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Opsæt restaurantens åbningstider',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Opsæt restaurantens placering',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Angiv restauranttype og køkkener, der vises på storefronten',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Opsæt indstillinger for afhentningstid',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Opsæt indstillinger for leveringstid',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Opsæt personalelogin',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importér menu fra tredjepartsudbyder',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Markér 4 varer som favoritter. Spørg restauranten, hvilke 4 retter der er mest populære',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Konfigurer adfærd for udsolgte varer',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Konfigurer rabatkoder',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Opdater galleri',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Hent logoet fra restauranten eller restaurantens side på Lieferando, og gem logoet derfra. Vælg den farve, der er mest fremtrædende i restaurantens logo',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Rediger flyerdesign og opret bestilling',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Opret storefront, og rediger websitet om nødvendigt',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Aktivér live-bestillinger („!kun på lanceringsdatoen!“)',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Tilslut Google Business-konto',
  },
  buttons: {
    mark_as_complete: 'Markér som fuldført',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
  },
};
